import React from "react";

import { useAuth } from "@/components/AuthContext";
import EventSettingsScreenContainer from "@/components/EventSettingsScreenContainer";
import Callout from "@/components/settings/Callout";
import { SettingsPage } from "@/components/settings/SettingsPage";
import { hasOwnTeam } from "@/components/teams/flag";
import TeamMembers from "@/components/teams/TeamMembers";
import TeamsForBusiness from "@/components/teams/TeamsForBusiness";
import { useTeamAccess } from "@/components/teams/useWorkspace";
import { t } from "@/localization";

// Profile › Team (PLAN.md §5.5): the people who work in this account with
// their own sign-in. In your own account it's your team (business accounts);
// while you work in someone else's account as an admin, it's theirs.
const Team = () => {
  const team = useTeamAccess();
  const { account_type } = useAuth();
  const managesShared = team.isShared && team.can("manageTeam");

  if (!team.isShared && !hasOwnTeam(account_type)) {
    return (
      <EventSettingsScreenContainer fallbackRoute="Profile">
        <SettingsPage title={t("Team")}>
          <TeamsForBusiness />
        </SettingsPage>
      </EventSettingsScreenContainer>
    );
  }

  if (team.isShared && !managesShared) {
    return (
      <EventSettingsScreenContainer fallbackRoute="Profile">
        <SettingsPage title={t("Team")}>
          <Callout tone="info">
            {t(
              "Only admins of {team}'s account can see its team. Switch to your own account to manage yours.",
              { team: team.name }
            )}
          </Callout>
        </SettingsPage>
      </EventSettingsScreenContainer>
    );
  }

  return (
    <EventSettingsScreenContainer fallbackRoute="Profile">
      <SettingsPage
        title={
          managesShared ? t("{team}'s team", { team: team.name }) : t("Team")
        }
        description={
          managesShared
            ? t("People who work in this account with their own sign-in.")
            : t(
                "People who work in your account with their own sign-in. You keep your plan, your purchases and your account."
              )
        }
      >
        <TeamMembers key={team.owner || "own"} self={team.self} />
      </SettingsPage>
    </EventSettingsScreenContainer>
  );
};

export default Team;
